import React from "react";
import fonepayLogo from "../assets/fonepay.png";
import paymentImage from "../assets/payment.png";
import { FaWhatsapp } from "react-icons/fa";

const FonePay = () => {
  return (
    <div className="py-8 px-4 max-w-screen-xl mx-auto">
      {/* Heading and Description */}
      <h1 className="text-4xl font-bold text-red-600 mb-2">
        Our Payment Options
      </h1>
      <p className="text-gray-600 mb-8">
        We have made available the following payment options for easiest
        transactions. Please feel free to use any one per your choice.
      </p>

      {/* Payment Options Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-white p-6 rounded-lg shadow-md">
        {/* Pay via Fonepay */}
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <img
              src={fonepayLogo}
              alt="Fonepay Logo"
              className="h-6 px-1 bg-white"
            />
            <h2 className="text-xl font-semibold text-red-500">Pay via Fonepay</h2>
          </div>
         
          <img
            src={paymentImage}
            alt="Payment Instructions"
            className="w-full max-w-xs mx-auto"
          />
          
          <div className="flex justify-center space-x-4">
            <button className="bg-red-500 text-white px-4 py-2 rounded">
              Open your Fonepay Mobile, Internet Banking App, Digital Wallet (Khalti, UnionPay)
            </button>
          </div>
        </div>

        {/* Pay via Bank Transfer */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-red-500">Pay via Bank Transfer</h2>
          <p className="text-gray-600">
            In order to pay via Bank Transfer, Virtueista I.T. Private Limited has the
            following banks:
          </p>
          <div className="flex items-center space-x-2 bg-gray-200">
            <div className="w-12 h-12 rounded flex items-center justify-center">
              <span className="text-blue-500 font-semibold">Bank</span>
            </div>
            <span className="text-blue-500 font-semibold">Transfer</span>
          </div>
          <div className="space-y-1">
            <h3 className="font-semibold">Siddhartha Bank Details:</h3>
            <p>
              <span className="font-medium">Bank Name:</span> Siddhartha Bank
              Ltd.
            </p>
            <p>
              <span className="font-medium">Account Name:</span> Virtueista I.T. Private Limited
            </p>
            <p>
              <span className="font-medium">Account Number:</span> 2222050018297245 
            </p>
            <p>
              <span className="font-medium">Branch:</span> Mahendra Chowk
            </p>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations */}
      <style>
        {`
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default FonePay;
